import {
	IoIosCheckmarkCircle,
	IoIosCloseCircle,
	IoIosHelpCircle,
} from 'react-icons/io';

import { accountStatusColor } from './accountStatusColor';

import { IUser } from '@/interfaces/entities/user';
import { AccountStatus } from '@/interfaces/entities/user.account-status';

export const accountStatus = (user: IUser) => {
	const color = accountStatusColor(user);
	switch (user.applicationRequest) {
		case AccountStatus.Accepted:
			return (
				<IoIosCheckmarkCircle
					className={`${color} inline-block align-middle`}
					title={AccountStatus.Accepted}
					size={22}
				/>
			);
		case AccountStatus.Rejected:
			return (
				<IoIosCloseCircle
					className={`${color} inline-block align-middle`}
					title={AccountStatus.Rejected}
					size={22}
				/>
			);
		case AccountStatus.Pending:
			return (
				<IoIosHelpCircle
					className={`${color} inline-block align-middle`}
					title={AccountStatus.Pending}
					size={22}
				/>
			);
		default:
			return null;
	}
};
